/* Glow Oil Mini (October '26).
   1) PDP FULL SIZE / MINI tabs: the MINI tab swaps the first gallery slide
      to the mini image and shows the Coming Soon + waitlist panel while
      hiding price copy, quantity and buy buttons.
   2) Waitlist result (homepage offering section + PDP, snippet
      sesen-mini-waitlist): Shopify flags every customer form on the page as
      posted, so the success/error line is revealed only for the form that
      was submitted (URL fragment = that form's id), then its MINI tab is
      opened and the block scrolled into view. Vanilla JS. */
(function () {
  'use strict';

  function initTabs(tabs) {
    if (tabs.dataset.miniInit) return;
    tabs.dataset.miniInit = '1';
    var section = tabs.closest('.main-product--section');
    if (!section) return;
    var btns = Array.prototype.slice.call(tabs.querySelectorAll('[data-mini-tab]'));

    function setMini(mini, btn) {
      btns.forEach(function (o) {
        var active = mini ? o === btn : o.dataset.miniTab === 'full';
        o.classList.toggle('is-active', active);
        o.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      section.classList.toggle('pdp-mini-active', mini);
      var img = section.querySelector('.of-pdp .of-slide img');
      if (img) {
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.getAttribute('src') || '';
          img.dataset.origSrcset = img.getAttribute('srcset') || '';
          img.dataset.origAlt = img.getAttribute('alt') || '';
        }
        var miniImage = btn && btn.dataset.miniImage;
        if (mini && miniImage) {
          img.removeAttribute('srcset');
          img.setAttribute('src', miniImage);
          if (btn.dataset.miniAlt) img.setAttribute('alt', btn.dataset.miniAlt);
        } else {
          img.setAttribute('src', img.dataset.origSrc);
          if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
          img.setAttribute('alt', img.dataset.origAlt);
        }
      }
      if (mini) {
        Array.prototype.forEach.call(section.querySelectorAll('.of-pdp video'), function (v) {
          if (!v.paused) v.pause();
        });
      }
      var track = section.querySelector('.of-pdp [data-of-track]');
      if (track) track.scrollTo({ left: 0 });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-active')) return;
        setMini(b.dataset.miniTab === 'mini', b);
      });
    });
  }

  function openMiniTab(block) {
    var scope = block.closest('[data-offering-feature]') || block.closest('.main-product--section');
    if (!scope) return;
    var tab = scope.querySelector('[data-of-tab][data-mini="1"], [data-mini-tab="mini"]');
    if (tab && !tab.classList.contains('is-active')) tab.click();
  }

  function initWaitlist(block) {
    if (block.dataset.miniWaitlistInit) return;
    block.dataset.miniWaitlistInit = '1';
    var form = block.querySelector('form');
    var hash = location.hash ? location.hash.slice(1) : '';
    if (!form || !hash || (hash !== form.id && hash !== block.id)) return;

    var success = block.querySelector('[data-mini-success]');
    var error = block.querySelector('[data-mini-error]');
    var fields = block.querySelector('[data-mini-fields]');
    if (success) {
      success.hidden = false;
      if (fields) fields.hidden = true;
    } else if (error) {
      error.hidden = false;
      var input = block.querySelector('input[type="email"]');
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        var described = input.getAttribute('aria-describedby');
        input.setAttribute('aria-describedby', described ? error.id + ' ' + described : error.id);
      }
    }
    window.setTimeout(function () {
      openMiniTab(block);
      block.scrollIntoView({ block: 'center' });
    }, 0);
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-mini-tabs]'), initTabs);
    Array.prototype.forEach.call(root.querySelectorAll('[data-mini-waitlist]'), initWaitlist);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
